export default __webpack_public_path__ + "static/media/perfume.437dafcb.svg";